import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { roles } from '../constant/constant';
import { JwtPayload } from '../models/AuthResult';

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    private readonly helper = new JwtHelperService();

    private decodeSession(): JwtPayload {
        const token = sessionStorage.getItem('authtoken');
        return this.helper.decodeToken(token);
    }

    public findRole(): roles {
        return this.decodeSession().role;
    }

    public findRoleId(): number {
        return this.decodeSession().role_id;
    }
}
